export const ErrorCircleIcon = () => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2884_3019)">
      <path d="M7.00008 1.6665C3.78591 1.6665 1.16675 4.28567 1.16675 7.49984C1.16675 10.714 3.78591 13.3332 7.00008 13.3332C10.2142 13.3332 12.8334 10.714 12.8334 7.49984C12.8334 4.28567 10.2142 1.6665 7.00008 1.6665ZM7.00008 12.1665C4.42758 12.1665 2.33341 10.0723 2.33341 7.49984C2.33341 4.92734 4.42758 2.83317 7.00008 2.83317C9.57258 2.83317 11.6667 4.92734 11.6667 7.49984C11.6667 10.0723 9.57258 12.1665 7.00008 12.1665Z" />
      <path d="M4.93764 6.26256C4.71078 6.0357 4.71078 5.66447 4.93764 5.43761C5.1645 5.21074 5.53573 5.21074 5.7626 5.43761L7.00003 6.67504L8.23747 5.43761C8.46433 5.21074 8.83557 5.21074 9.06243 5.43761C9.28929 5.66447 9.28929 6.0357 9.06243 6.26256L7.82499 7.5L9.06243 8.73744C9.28929 8.9643 9.28929 9.33553 9.06243 9.56239C8.83557 9.78926 8.46433 9.78926 8.23747 9.56239L7.00003 8.32496L5.7626 9.56239C5.53573 9.78926 5.1645 9.78926 4.93764 9.56239C4.71078 9.33553 4.71078 8.9643 4.93764 8.73744L6.17508 7.5L4.93764 6.26256Z" />
    </g>
    <defs>
      <clipPath id="clip0_2884_3019">
        <rect
          width="14"
          height="14"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
